const api = {
  pacient: '/api/pacient',
  planuriTratament: '/api/planuri-tratament',
  planTratament: '/api/plan-tratament'
};

export default api;
